import { useState, useEffect, useCallback } from "react";
import { getChequeExtensionHistory } from "../api";
import moment from "moment";
import { getFilterDate } from "modules/paymentManagement/approvalDashboard/shared/constant";

export const useFetchList = (fetchListApi, { 
    initialPage = 0, 
    initialPageSize = 50, 
    businessAreaId,
    initialFilters = {},
    depositId,
    cashierOffice,
    statusFilters = [],
    enabled = true // <--- 1. CONTROL FLAG (Default True)
} = {}) => {
  
  const [rows, setRows] = useState([]); 
  const [loading, setLoading] = useState(false);
  
  const [pagination, setPagination] = useState({
    page: initialPage,
    pageSize: initialPageSize,
    total: 0,
    totalPages: 0,
  });

  const [filters, setFilters] = useState(initialFilters);

  // --- API CALL ---
  const loadData = useCallback(async () => {
    // 2. BLOCKER: Do not fetch if not enabled
    if (!enabled) return;

    setLoading(true);
    try {
        
      const requestPayload = {
        pageNo: pagination.page,
        pageSize: pagination.pageSize,
        ...filters, 
      };


    
      const res = await fetchListApi(requestPayload,businessAreaId ,depositId, cashierOffice, { statusFilters });
      
      // Safety check for response structure
      const apiResponse = res?.data || {}; 
      
      setRows(apiResponse['paginatedData'] || []);
      
      setPagination((prev) => ({
        ...prev,
        total: apiResponse?.totalRecords || 0,
        totalPages: apiResponse?.totalPage || 0,
      }));
    } catch (err) {
      console.error("API failed:", err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [fetchListApi, pagination.page, pagination.pageSize, filters, enabled]); // Added 'enabled' dep

  // --- EFFECTS ---
  useEffect(() => {
    // 3. TRIGGER: Only run if enabled
    if (enabled) {
        loadData();
    }
  }, [loadData, enabled]);


      const fetchTrackerTimeLine = async (referenceNumber) => {
        try{
          setLoading(true);
          const res = await getChequeExtensionHistory(referenceNumber)
         return res
        }catch(err){
          console.error("Error fetching tracker timeline:", err);
        }
        finally{
          setLoading(false);
        }

      }

  // --- EXPORT ---
  return {
    rows, 
    loading,
    pagination,
    filters,
    
    onPageChange: (p) => setPagination(prev => ({ ...prev, page: p-1 })),
    onPageSizeChange: (s) => setPagination(prev => ({ ...prev, pageSize: s, page: 0 })),
    
    onFilterApply: (newFilters) => {
        console.log(newFilters, "newFilters")
        setFilters({...newFilters,startDate:getFilterDate(newFilters?.startDate,'start'), endDate:getFilterDate(newFilters?.endDate,'end'), receiptDateFrom: newFilters.receiptDateFrom ? moment(newFilters?.receiptDateFrom)?.startOf('day') : '', receiptDateTo: newFilters.receiptDateTo ? moment(newFilters?.receiptDateTo)?.endOf('day') : ''});
        setPagination(prev => ({ ...prev, page: 0 })); 
    },
    setFilters,
    reload: loadData,
    fetchTrackerTimeLine
  };
};